import Naluri from '~/common/api/naluri';
import { sortWith, descend, prop, groupBy } from 'ramda';
import {
  COMMON_SEARCH_CHANNELSV2_BEGIN,
  COMMON_SEARCH_CHANNELSV2_SUCCESS,
  COMMON_SEARCH_CHANNELSV2_FAILURE,
  COMMON_SEARCH_CHANNELSV2_DISMISS_ERROR,
  COMMON_SEARCH_CHANNELSV2_CLEAR,
} from './constants';
import { List } from 'immutable';

export function searchChannelsV2(keyword, filter, to_reply, paid, vip) {
  return dispatch => {
    dispatch({
      type: COMMON_SEARCH_CHANNELSV2_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const params = {
        query: keyword,
        to_reply,
        paid,
        vip,
        sponsors: filter,
        include_status: true,
      };

      const doRequest = Naluri.get(`/api/expert/channels/search`, params);

      doRequest.then(
        res => {
          dispatch({
            type: COMMON_SEARCH_CHANNELSV2_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: COMMON_SEARCH_CHANNELSV2_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetBroadcastUsersError() {
  return {
    type: COMMON_SEARCH_CHANNELSV2_DISMISS_ERROR,
  };
}

const filterUsers = users => {
  const byUnread = sortWith([descend(prop('unreads_count'))]);
  const byStatus = sortWith([
    (a, b) => {
      const u1 = users.find(u => u.id === a.id);
      const u2 = users.find(u => u.id === b.id);
      const l1 = u1.status ? u1.status.length : 0;
      const l2 = u2.status ? u2.status.length : 0;

      return l2 - l1;
    },
  ]);

  const groupByStatusAndUnread = groupBy(a => {
    return a.unreads_count === 0 ? 'unread0' : a.status === 'online' ? 'online' : 'offline';
  });

  let onlineUsers = [];
  let offlineUsers = [];
  let unreadUsers = [];

  const groupedUsers = groupByStatusAndUnread(users);

  Object.keys(groupedUsers).forEach(key => {
    if (key === 'online') {
      onlineUsers = byUnread(groupedUsers[key]);
    } else if (key === 'offline') {
      offlineUsers = byUnread(groupedUsers[key]);
    } else {
      unreadUsers = byStatus(groupedUsers[key]);
    }
  });

  return [...onlineUsers, ...offlineUsers, ...unreadUsers];
};

export function clearSearch() {
  return (dispatch, getState) => {
    dispatch({
      type: COMMON_SEARCH_CHANNELSV2_BEGIN,
    });

    dispatch({
      type: COMMON_SEARCH_CHANNELSV2_CLEAR,
    });
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SEARCH_CHANNELSV2_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        searchChannelsV2Pending: true,
        searchChannelsV2Error: null,
      };

    case COMMON_SEARCH_CHANNELSV2_SUCCESS:
      // The request is success

      const searchChannelResults = state.searchChannelResults.withMutations(broadcast =>
        action.data.map(u => {
          let isExist = broadcast.find(b => b.channel_id === u.channel_id);
          return !isExist ? broadcast.push(u) : null;
        }),
      );

      const sorted = filterUsers(searchChannelResults.toArray());

      return {
        ...state,
        searchChannelResults: searchChannelResults,
        sortedSearchResults: sorted,
        searchChannelsV2Pending: false,
        searchChannelsV2Error: null,
      };

    case COMMON_SEARCH_CHANNELSV2_FAILURE:
      // The request is failed
      return {
        ...state,
        searchChannelsV2Pending: false,
        searchChannelsV2Error: action.data.error,
      };

    case COMMON_SEARCH_CHANNELSV2_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        searchChannelsV2Error: null,
      };

    case COMMON_SEARCH_CHANNELSV2_CLEAR:
      // Dismiss the request failure error
      return {
        ...state,
        searchChannelResults: List(),
        sortedSearchResults: [],
        searchChannelsV2Pending: false,
        searchChannelsV2Error: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/searchChannelsV2.js